import { createReducer, on } from '@ngrx/store';
import { Toast } from '../../toast/model/toast';
import * as toastActions from '../actions/toast.actions';

export interface State {
  toasts: string[];
  toast: Toast;
}

const initialState: State = {
	toasts: [],
	toast: null
};

export const reducer = createReducer(
  initialState,
  on(toastActions.Show, (state, action) => ({
    ...state,
    toast: action.toast,
  })),
  on(toastActions.Hide, (state, action) => ({
    ...state,
    toast: null,
  })),
);

